// Password checking and access cookies belong to Shopify. This only reveals the field.
(() => {
  const setup = (root = document) => {
    root.querySelectorAll('[data-password-toggle]').forEach(button => { button.hidden = false; });
  };
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-password-toggle]');
    if (!button) return;
    const input = document.getElementById(button.getAttribute('aria-controls'));
    if (!input || !button.closest('form')?.contains(input)) return;
    const show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    button.textContent = show ? 'Hide' : 'Show';
    button.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
    button.setAttribute('aria-pressed', String(show));
  });
})();
